import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path stroke={color} strokeWidth="2" d="M15.294 4L20 8.706v6.588L15.294 20H8.706L4 15.294V8.706L8.706 4z" />
      <path fill={color} d="M11 15h2v2h-2zM11 7h2v6h-2z" />
    </g>
  </svg>
);
